// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-editor {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #0f172a;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #334155;
  background-color: #1e293b;
}

.editor-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.close-button {
  background: none;
  border: none;
  color: #cbd5e1;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.close-button:hover {
  color: #f1f5f9;
}

.editor-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}

.editor-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

.section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #334155;
}

.section:last-child {
  border-bottom: none;
}

.section h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #f1f5f9;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #cbd5e1;
}

.form-group input,
.form-group select,
.form-group input[type='time'] {
  padding: 10px 12px;
  background-color: #1e293b;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s;
  min-height: 42px;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group input[type='time']:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.server-id-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
}

.server-id-box label {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.server-id-display {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #cbd5e1;
  word-break: break-all;
  padding: 8px;
  background-color: #0f172a;
  border-radius: 4px;
  border: 1px solid #475569;
  -webkit-user-select: all;
          user-select: all;
}

.championship-summary {
  margin-bottom: 16px;
  padding: 14px;
  background-color: #111827;
  border: 1px solid #334155;
  border-radius: 8px;
}

.championship-summary-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.summary-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.summary-value {
  font-size: 14px;
  color: #f1f5f9;
  line-height: 1.4;
}

.rotation-plan-box {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: #0f172a;
  border: 1px solid #475569;
  border-radius: 6px;
}

.rotate-now-button {
  background-color: #22c55e;
  color: #0f172a;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.rotate-now-button:hover:not(:disabled) {
  background-color: #16a34a;
}

.rotation-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.sync-now-button {
  background-color: #0284c7;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.sync-now-button:hover:not(:disabled) {
  background-color: #0369a1;
}

.sync-now-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.rotate-now-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.rotation-message {
  margin-top: 10px;
  font-size: 13px;
  line-height: 1.4;
}

.rotation-message.success {
  color: #86efac;
}

.rotation-message.error {
  color: #fda4af;
}

.form-group input::placeholder {
  color: #64748b;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.session-section .form-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  align-items: end;
}
.session-section {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.session-section > h3,
.session-section > .race-type-group {
  flex: 0 0 100%;
}

.session-section > .form-row {
  flex: 1 1 300px;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.session-section .form-group {
  min-width: 0;
  margin-bottom: 0;
}

.session-section .form-group input,
.session-section .form-group select {
  width: 100%;
  max-width: none;
}

.session-section .form-group input:disabled,
.session-section .form-group select:disabled {
  color: #64748b;
  background-color: #172033;
  border-color: #334155;
  opacity: 1;
  cursor: not-allowed;
}

.session-section .form-group input[type="checkbox"]:disabled {
  accent-color: #475569;
  opacity: 0.45;
}

.session-section .form-group:has(input:disabled) label {
  color: #64748b;
}

.session-section .compact-input,
.session-section .compact-time-input {
  max-width: none;
}

@media (max-width: 500px) {
  .session-section .form-row {
    grid-template-columns: 1fr;
  }
}

.track-info {
  padding: 12px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  margin-bottom: 16px;
}

.track-info p {
  margin: 4px 0;
  font-size: 14px;
  color: #cbd5e1;
}

.track-info strong {
  color: #f1f5f9;
}

.info-box {
  padding: 12px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  margin-top: 12px;
}

.info-box p {
  margin: 4px 0;
  font-size: 14px;
  color: #cbd5e1;
}

.info-box strong {
  color: #f1f5f9;
}

.cars-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.car-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background-color: #1e293b;
  border: 1px solid #475569;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.car-checkbox:hover {
  background-color: #334155;
  border-color: #64748b;
}

.car-checkbox input[type='checkbox'] {
  display: none;
}

.car-checkbox input[type='checkbox']:checked ~ .checkmark {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

.car-checkbox input[type='checkbox']:checked ~ .checkmark:after {
  display: block;
}

.checkmark {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: 1px solid #64748b;
  border-radius: 4px;
  transition: all 0.2s;
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.car-name {
  flex: 1 1;
  font-size: 13px;
  color: #e2e8f0;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.editor-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #64748b;
}

.server-editor .editor-actions {
  display: flex;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #334155;
  background-color: #1e293b;
}

.server-editor .save-button,
.server-editor .delete-button,
.server-editor .cancel-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  flex: 1 1;
  justify-content: center;
}

.server-editor .save-button {
  background-color: #3b82f6;
  color: white;
}

.server-editor .save-button:hover {
  background-color: #2563eb;
}

.server-editor .delete-button {
  background-color: #ef4444;
  color: white;
}

.server-editor .delete-button:hover {
  background-color: #dc2626;
}

.server-editor .cancel-button {
  background-color: transparent;
  color: #cbd5e1;
  border: 1px solid #475569;
}

.server-editor .cancel-button:hover {
  background-color: #1e293b;
  border-color: #64748b;
  color: #f1f5f9;
}

/* Header buttons container */
.header-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.view-json-button {
  background: none;
  border: none;
  color: #cbd5e1;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  border-radius: 4px;
}

.view-json-button:hover {
  color: #60a5fa;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  max-width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  width: 900px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #334155;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #f1f5f9;
}

.modal-close {
  background: none;
  border: none;
  color: #cbd5e1;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #f1f5f9;
}

.modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

.json-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.json-section {
  display: flex;
  flex-direction: column;
}

.json-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #cbd5e1;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.json-viewer {
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 4px;
  padding: 12px;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 11px;
  color: #e2e8f0;
  overflow: auto;
  max-height: 400px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":[".server-editor {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #0f172a;\r\n}\r\n\r\n.editor-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #334155;\r\n  background-color: #1e293b;\r\n}\r\n\r\n.editor-header h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.close-button:hover {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.editor-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.editor-scroll {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n}\r\n\r\n.section {\r\n  margin-bottom: 30px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.section:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.section h3 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.form-group label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group input[type='time'] {\r\n  padding: 10px 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n  color: #f1f5f9;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  transition: all 0.2s;\r\n  min-height: 42px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group input[type='time']:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.server-id-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  padding: 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n}\r\n\r\n.server-id-box label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #94a3b8;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.server-id-display {\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 13px;\r\n  color: #cbd5e1;\r\n  word-break: break-all;\r\n  padding: 8px;\r\n  background-color: #0f172a;\r\n  border-radius: 4px;\r\n  border: 1px solid #475569;\r\n  user-select: all;\r\n}\r\n\r\n.championship-summary {\r\n  margin-bottom: 16px;\r\n  padding: 14px;\r\n  background-color: #111827;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n}\r\n\r\n.championship-summary-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  gap: 12px;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.summary-label {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  color: #94a3b8;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.summary-value {\r\n  font-size: 14px;\r\n  color: #f1f5f9;\r\n  line-height: 1.4;\r\n}\r\n\r\n.rotation-plan-box {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n}\r\n\r\n.rotate-now-button {\r\n  background-color: #22c55e;\r\n  color: #0f172a;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.rotate-now-button:hover:not(:disabled) {\r\n  background-color: #16a34a;\r\n}\r\n\r\n.rotation-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sync-now-button {\r\n  background-color: #0284c7;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.sync-now-button:hover:not(:disabled) {\r\n  background-color: #0369a1;\r\n}\r\n\r\n.sync-now-button:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rotate-now-button:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rotation-message {\r\n  margin-top: 10px;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.rotation-message.success {\r\n  color: #86efac;\r\n}\r\n\r\n.rotation-message.error {\r\n  color: #fda4af;\r\n}\r\n\r\n.form-group input::placeholder {\r\n  color: #64748b;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 16px;\r\n}\r\n\r\n.session-section .form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 12px;\r\n  align-items: end;\r\n}\r\n.session-section {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n}\r\n\r\n.session-section > h3,\r\n.session-section > .race-type-group {\r\n  flex: 0 0 100%;\r\n}\r\n\r\n.session-section > .form-row {\r\n  flex: 1 1 300px;\r\n  min-width: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.session-section .form-group {\r\n  min-width: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.session-section .form-group input,\r\n.session-section .form-group select {\r\n  width: 100%;\r\n  max-width: none;\r\n}\r\n\r\n.session-section .form-group input:disabled,\r\n.session-section .form-group select:disabled {\r\n  color: #64748b;\r\n  background-color: #172033;\r\n  border-color: #334155;\r\n  opacity: 1;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.session-section .form-group input[type=\"checkbox\"]:disabled {\r\n  accent-color: #475569;\r\n  opacity: 0.45;\r\n}\r\n\r\n.session-section .form-group:has(input:disabled) label {\r\n  color: #64748b;\r\n}\r\n\r\n.session-section .compact-input,\r\n.session-section .compact-time-input {\r\n  max-width: none;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .session-section .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.track-info {\r\n  padding: 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.track-info p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.track-info strong {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.info-box {\r\n  padding: 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.info-box p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.info-box strong {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.cars-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.car-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.car-checkbox:hover {\r\n  background-color: #334155;\r\n  border-color: #64748b;\r\n}\r\n\r\n.car-checkbox input[type='checkbox'] {\r\n  display: none;\r\n}\r\n\r\n.car-checkbox input[type='checkbox']:checked ~ .checkmark {\r\n  background-color: #3b82f6;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.car-checkbox input[type='checkbox']:checked ~ .checkmark:after {\r\n  display: block;\r\n}\r\n\r\n.checkmark {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: transparent;\r\n  border: 1px solid #64748b;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.checkmark:after {\r\n  content: '';\r\n  position: absolute;\r\n  display: none;\r\n  left: 5px;\r\n  top: 2px;\r\n  width: 5px;\r\n  height: 9px;\r\n  border: solid white;\r\n  border-width: 0 2px 2px 0;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.car-name {\r\n  flex: 1;\r\n  font-size: 13px;\r\n  color: #e2e8f0;\r\n  min-width: 0;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.editor-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  color: #64748b;\r\n}\r\n\r\n.server-editor .editor-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  padding: 20px;\r\n  border-top: 1px solid #334155;\r\n  background-color: #1e293b;\r\n}\r\n\r\n.server-editor .save-button,\r\n.server-editor .delete-button,\r\n.server-editor .cancel-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  flex: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.server-editor .save-button {\r\n  background-color: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n.server-editor .save-button:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.server-editor .delete-button {\r\n  background-color: #ef4444;\r\n  color: white;\r\n}\r\n\r\n.server-editor .delete-button:hover {\r\n  background-color: #dc2626;\r\n}\r\n\r\n.server-editor .cancel-button {\r\n  background-color: transparent;\r\n  color: #cbd5e1;\r\n  border: 1px solid #475569;\r\n}\r\n\r\n.server-editor .cancel-button:hover {\r\n  background-color: #1e293b;\r\n  border-color: #64748b;\r\n  color: #f1f5f9;\r\n}\r\n\r\n/* Header buttons container */\r\n.header-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.view-json-button {\r\n  background: none;\r\n  border: none;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n  border-radius: 4px;\r\n}\r\n\r\n.view-json-button:hover {\r\n  color: #60a5fa;\r\n}\r\n\r\n/* Modal styles */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  max-width: 90%;\r\n  max-height: 85vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 900px;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.modal-close {\r\n  background: none;\r\n  border: none;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.modal-close:hover {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.modal-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n}\r\n\r\n.json-tabs {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 20px;\r\n}\r\n\r\n.json-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.json-section h4 {\r\n  margin: 0 0 12px 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.json-viewer {\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  padding: 12px;\r\n  font-family: 'Monaco', 'Courier New', monospace;\r\n  font-size: 11px;\r\n  color: #e2e8f0;\r\n  overflow: auto;\r\n  max-height: 400px;\r\n  margin: 0;\r\n  white-space: pre-wrap;\r\n  word-break: break-all;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
